export default __webpack_public_path__ + "static/B20-54bad7ef475d4dfdf9bdc320a29dab98.png";